import React, { useCallback, useMemo } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { AccountForms, accountService, FormStatus } from '@lib/state';
import {
  CreateAccountForm,
  FormHub,
  useFormEvents,
  CreateAccountFormFields,
  ResponsiveContainer,
} from '@lib/common';

export const CreateAccountPage: React.FC<RouteComponentProps> = ({ location }) => {
  const redirectTo = useMemo(() => new URLSearchParams(location.search).get('redirect'), [
    location,
  ]);

  const [{ status, error }] = useFormEvents(AccountForms.CreateAccount);

  const submit = useCallback(
    ({ contact, name, address, password }: CreateAccountFormFields) =>
      accountService.createAccount(contact.email, contact.phone, name, address, password),
    []
  );

  if (status === FormStatus.Success) {
    return <Redirect to={redirectTo ?? '/profile'} />;
  }

  return (
    <ResponsiveContainer>
      <FormHub onSubmit={submit}>
        <Typography
          variant="h5"
          align="center"
          color="textSecondary"
          paragraph
          data-testid="formCreateAccTitle"
        >
          Create Account
        </Typography>
        <CreateAccountForm status={status} error={error} />
      </FormHub>
    </ResponsiveContainer>
  );
};
